module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.docs.dpc) ? _c('ul', {
    staticClass: "lista-downloads"
  }, [_c('li', {
    staticClass: "prod"
  }, [_vm._v("DPC - Declaração de Práticas de Certificação")]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": _vm.docs.dpc
    }
  }, [_vm._v(" DPC " + _vm._s(_vm.nomeac))]), _vm._v(" "), _c('span')])]) : _vm._e(), _vm._v(" "), (_vm.docs.cps) ? _c('ul', {
    staticClass: "lista-downloads"
  }, [_c('li', {
    staticClass: "prod"
  }, [_vm._v("CPS  - Certification Practice Statement")]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": _vm.docs.cps
    }
  }, [_vm._v(" CPS CA  " + _vm._s(_vm.nomeac))]), _vm._v(" "), _c('span')])]) : _vm._e(), _vm._v(" "), (_vm.docs.kgar) ? _c('ul', {
    staticClass: "lista-downloads"
  }, [_c('li', {
    staticClass: "prod"
  }, [_vm._v("Relatório de Auditoria - Geração de Chave")]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": _vm.docs.kgar
    }
  }, [_vm._v(" Key Generation Audit Report")]), _vm._v(" "), _c('span')])]) : _vm._e(), _vm._v(" "), (_vm.docs.pc) ? _c('ul', {
    staticClass: "lista-downloads"
  }, [_c('li', {
    staticClass: "prod"
  }, [(_vm.nomeac != 'ACT SOLUTI') ? _c('span', [_vm._v("PC - Política de Certificado")]) : _c('span', [_vm._v("PCT - Política de Carimbo de Tempo")])]), _vm._v(" "), _vm._l((_vm.docs.pc), function(item) {
    return _c('li', [(!item.infoName) ? _c('a', {
      attrs: {
        "href": item.arquivo
      }
    }, [(_vm.nomeac != 'ACT SOLUTI') ? _c('pct', [_vm._v("AC " + _vm._s(_vm.nomeac) + " - PC " + _vm._s(item.nome))]) : _c('pct', [_vm._v(" " + _vm._s(_vm.nomeac) + " - PCT " + _vm._s(item.nome) + " ")])], 1) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.descricao) + " "), (!item.infoName) ? _c('tp', [_vm._v("- Tipo " + _vm._s(item.nome) + " ")]) : _vm._e()], 1)])
  })], 2) : _vm._e(), _vm._v(" "), (_vm.docs.ps) ? _c('ul', {
    staticClass: "lista-downloads"
  }, [_c('li', {
    staticClass: "prod"
  }, [_vm._v("PS - Política de Segurança")]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": _vm.docs.ps
    }
  }, [_vm._v("PS " + _vm._s(_vm.nomeac))]), _vm._v(" "), _c('span')])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5ab156f6!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/RepositorioDocs.vue
// module id = 102
// module chunks = 0